import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { LayoutSlots } from '../types';

interface Props<Context extends any = any> extends LayoutSlots<Context> {
  context: Context;
  table: React.ReactNode;
}

const buildGridTemplateRows = (top: boolean, renderTop: boolean, renderBottom: boolean, bottom: boolean): string =>
  [top && 'auto', renderTop && 'auto', '1fr', renderBottom && 'auto', bottom && 'auto'].filter(Boolean).join(' ');

export const Layout = <Context extends any = any>({
  table,
  context,
  actionPanelTop,
  ActionPanelTop,
  ActionPanelBottom,
  actionPanelBottom,
}: Props<Context>) => {
  const gridTemplateRows = useMemo(
    () => buildGridTemplateRows(!!ActionPanelTop, !!actionPanelTop, !!actionPanelBottom, !!ActionPanelBottom),
    [ActionPanelTop, ActionPanelBottom, actionPanelTop, actionPanelBottom]
  );

  return (
    <Box sx={{ display: 'grid', gridTemplateRows, height: '100%', gap: '0.5rem' }}>
      {ActionPanelTop && <ActionPanelTop context={context} />}
      {actionPanelTop && actionPanelTop({ context })}
      {table}
      {actionPanelBottom && actionPanelBottom({ context })}
      {ActionPanelBottom && <ActionPanelBottom context={context} />}
    </Box>
  );
};
